import {produce} from 'immer';
import {useAtom} from 'jotai';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {useBackgroundClick} from '@/hooks';
import {useGA4WithParams} from '@/hooks/tracking';
import {nearbyInfoAtom} from '@/map/atom';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {ToolboxItemProps} from '../';
import {ReactComponent as MenuIcon} from '../assets/near-etc.svg';
import {ToolboxItem} from '../StyledComponents';
import {SelectInfoWindow} from './SelectInfoWindow';

const REPLACE_LABEL_PAIR: any = {
  장기요양기관: '요양원',
};

const replaceLabel = (origin: string) => REPLACE_LABEL_PAIR[origin] ?? origin;

const options = Object.values(AROUND_DATA_OPTIONS).map((i) => ({
  ...i,
  label: replaceLabel(i.label),
}));

export const NearbyInfoButton = (props: ToolboxItemProps) => {
  const [nearbyData, setNearby] = useAtom(nearbyInfoAtom);
  const [open, setOpen] = useState<boolean>(false);

  const selected = nearbyData.selected;
  const active = open || nearbyData.active;

  const menuRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useBackgroundClick(menuRef, () => setOpen((prev) => !prev), [buttonRef]);

  const tracking = useGA4WithParams();

  const onSelected = (nextSelected: string[]) => {
    setNearby(
      produce((draft) => {
        draft.selected = nextSelected as any;
      })
    );

    tracking('nearby_info', {
      nearby_array: nextSelected,
    });
  };

  const handleSwitch = (nextActive: boolean) => {
    setNearby(
      produce((draft) => {
        draft.active = nextActive;
      })
    );
  };

  useEffect(() => {
    // 지원 중단 주변 정보 필터링
    if (selected?.length) {
      const filtered = selected.filter((id) => options.find((i) => i.id === id));

      if (filtered.length !== selected.length) {
        setNearby(
          produce((draft) => {
            draft.selected = filtered;
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root>
      <ToolboxItem {...props} ref={buttonRef} active={active} onClick={() => setOpen((prev) => !prev)}>
        <MenuIcon />
      </ToolboxItem>
      {open && (
        <SelectInfoWindow
          title="주변 정보"
          type="정보"
          limit={options.length}
          active={nearbyData.active}
          ref={menuRef}
          options={options}
          selected={selected}
          onSelected={onSelected}
          onSwitchChanged={handleSwitch}
        />
      )}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
`;
